import styled from '@emotion/styled'

export const Step = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 25%;
  flex-direction: column;
  gap: 1rem;
`
